module.exports = __webpack_public_path__ + "static/media/designSketch.8879f891.svg";